/**
 * Suggested prompts configuration for RiseAI Chat cards in welcome screen
 */

import NRRemediateIcon from '../../NRIcons/NRRemediateIcon';
import NRCredentialIcon from '../../NRIcons/NRCredentialIcon';
import NRBinaryIcon from '../../NRIcons/NRBinaryIcon';
import NRCircleCriticalIcon from '../../NRIcons/NRCircleCriticalIcon';

export const SUGGESTED_PROMPTS = [
  {
    title: 'Fix Priorities',
    text: 'What should I fix first based on exploitability, EPSS, and known exploited vulnerabilities?',
    icon: NRRemediateIcon
  },
  {
    title: 'Digging Deeper',
    text: 'Does this asset contain any exposed credentials or private keys?',
    icon: NRCredentialIcon
  },
  {
    title: 'Binary Hardening Gaps',
    text: 'Which binaries are missing critical protections like NX, PIE, RELRO, or stack canaries?',
    icon: NRBinaryIcon
  },
  {
    title: 'High-Risk Components',
    text: 'What is the highest-risk component in this asset and what is the recommended remediation plan?',
    icon: NRCircleCriticalIcon
  }
];

/**
 * Capability labels and their long-form descriptions for the Welcome screen
 */
export const CAPABILITY_SUMMARIES = [
  {
    id: 'vulnPrioritization',
    label: 'Vuln Prioritization',
    description:
      "I explain the difference between severity (CVSS) and actual exploitation probability (EPSS), identify exploit maturity (weaponized, PoC, unproven), and flag any vulnerabilities on CISA's Known Exploited Vulnerabilities list — so you know exactly what to fix first."
  },
  {
    id: 'sbomComponents',
    label: 'SBOM & Components',
    description:
      'I break down how each component in your asset was identified (Package Manifests, Symbol Indexes, or Binary Fingerprints) and surface license types like Zlib that may carry legal or compliance risk.'
  },
  {
    id: 'binaryHardening',
    label: 'Binary Hardening',
    description:
      'I analyze how well your binaries are protected against common exploit techniques. I interpret the status of NX (No-eXecute), PIE (Position Independent Executable), Stack Canaries, and RELRO protections across every binary in the asset.'
  },
  {
    id: 'cryptoVisibility',
    label: 'Crypto Visibility',
    description:
      "I provide a summary of all cryptographic material in the asset — including certificate counts, public key exposure, and detection of any private keys bundled where they shouldn't be. I also surface expired or invalid certificates."
  },
  {
    id: 'aiDrivenInsights',
    label: 'AI-Driven Insights',
    description:
      'I interpret the NetRise engine Synopsis for your asset — including obfuscation flags, complex data manipulation patterns, and supply chain security implications you might otherwise miss.'
  },
  {
    id: 'remediationVex',
    label: 'Remediation & VEX',
    description:
      'I help you understand VEX (Vulnerability Exploitability eXchange) statuses for each component — whether it is Affected, Not Affected, or has a Workaround — and guide you through building a remediation workflow.'
  }
];
